import React from 'react';
import {groupPidArrs} from '../utilsFui';
import {cl,globs} from '../../components/utils/utils';

class StageOnOff extends React.Component{
  constructor(props) {
    super(props);
//     cl(props.current)
//     cl(props)
//     this.props.getValue(props.ind, {type: "array", count: 13})
    this.updateFui()
    this.makeRefs()
//     cl(this.refs2)
    this.ourKey=props?.orCommonControls?.filter(k=>{
      return k.split("-")[2]=="stageOnOff"})[0]
//     cl(this.ourKey)
    this.conflicts=this.checkConflicts2(props.commonValues)
    this.subscribe_updateFui=globs.events.subscribe("updateFui", this.updateFui)
//     cl(this.props.value)
  }

  updateFui=()=>{
    if(!this.changed){
      this.props.getValue(this.props.ind, {type: "array", count: 13})
    }
  }
  
  componentWillUnmount=()=>{
    this.subscribe_updateFui.remove()
//     this.subscribe_savePageEvent.remove()
  }
    
  onChange=(ind)=>{
//     cl("got on change")
//     cl(this.props.value)
    let stageStatus=this.props.value
//     cl(Array.isArray(stageStatus))
//     cl(stageStatus.length)
//     cl(!(stageStatus.length||0))
    if(!Array.isArray(stageStatus)){stageStatus=[0,0,0,0,0,0,0,0,0,0,0,0,0]}
//     cl(stageStatus)
    stageStatus[ind]=(+(stageStatus[ind]||0))?0:1
    this.setState({stageStatus: stageStatus})
//     cl(stageStatus)
    this.props.onChange(this.props.ind, {value: stageStatus})
    this.changed=true// blocks updating
  }
  
  checkConflicts=(commonValues)=>{
    if(!commonValues){return[]}
    let keys=Object.keys(commonValues)// zones
//     let conflicts=Array.from({length:7},e=>false)
    var conflicts
    let a0=commonValues[keys[0]]// values for first zone
    for(let i=1;i<keys.length;i++){
      let key=keys[i]
      if(key!="conflict"){
        let a=commonValues[keys[i]]
        if(!conflicts){conflicts=Array.from({length:a.length},e=>false)}
        a.forEach((v,i)=>{
          if(v!=a0[i]){conflicts[i]=true}
        })
      }
    }
//     cl(conflicts)
    return conflicts
  }

checkConflicts2 = (commonValues) => {
  // cl(commonValues, "----")
    // Return empty array if no commonValues
    if (!commonValues) {
        return []
    }
    let conflicts = Array(13).fill(false)
    // Get all keys except 'conflict'
    let keys = Object.keys(commonValues).filter(key => key !== 'conflict')
    if (keys.length < 2) {// If less than 2 zones, no conflicts possible
        return conflicts
    }
    // cl(keys.length, "keys length without conflict")
    let firstValue = Number(commonValues[keys[0]])
    // Compare other zones with first zone
    for (let i = 1; i < keys.length; i++) {
        let currentValue = Number(commonValues[keys[i]])
        cl(currentValue, firstValue)
        // If values are different, mark all positions as conflicting
        if (currentValue !== firstValue) {
            conflicts = conflicts.map(() => true)
            break
        }
    }

    return conflicts
}
  makeRefs=()=>{
    let cur=this.props.current
    this.refs2=[]
    for(let i=0; i<=12; i++){
      this.refs2[i]=React.createRef()
    }
  }

  showStageButtons=()=>{
//     cl("show")
//     cl(this.props.value)
    let pr=this.props
    let hs=pr.current.heatStages
    let cs=pr.current.coolStages
    if(hs==undefined){hs=6}
    if(cs==undefined){cs=6}
    // stage colors
    let colors=["#eb5555","#db5555","#cb5555","#bb5555","#ab5555","#ab7855",
      "#ababab","#55ab55","#55ab78","#55ab9a","#559aab","#5588cb","#5570eb"]
    let base=6-hs
    let col=colors[base]
//     cl(hs,cs)
    let head=[]
    let state=[]
    let vals=pr.value
//     cl(this.refs2)//{}
//     cl(vals)
    if(!vals.length){vals=[0,0,0,0,0,0,0,0,0,0,0,0,0]}
    for(let i=0-hs; i<=cs; i++){
      let st=+(pr.value[i+6]||0)
      let col=colors[base+(i+hs)]
      let name=(i<0)?`Heat${0-i}`:((i>0)?`Cool${i}`:`Normal`)
      let val=(st)?"ON":"OFF"
      head.push(<th key={i}>{name}</th>)
//       cl(st)
      let cell=(
        <button ref={this.refs2[i+6]}
            style={{backgroundColor:col,color:(st)?"white":"black",
                opacity:(st)?1.0:0.2
              }}
            className={`date toggle ${(st)?"selected":""}`}
            onClick={e=>{this.onChange(6+i)}}
        >
            {val}
        </button>

      )
      var key
      if(this.ourKey){
        let parts=this.ourKey.split("-")
        parts[1]=groupPidArrs.stageOnOff[i+6]
        key=parts.join("-")
      }
      if(this.conflicts[i+6]&&
        (!pr.orConflictOverrides.includes(key))){
//             cl("conflict",key)
        let control={
          cont:cell,
          ref:this.refs2[i+6],
          key:key,
          ind:pr.ind,
        }
//         cl(control)
        state.push(
        <td key={i}>
          {(pr.commonValues?.conflict)?pr.commonValues?.conflict(control,key,true):cell}
        </td>
        )
      }else{
        state.push(<td key={i}>{cell}</td>)
      }

//       state.push(
//         <td key={i}>
//         {cell}
//       </td>
//       )
    }
    return(
      <table><tbody>  
      <tr>{head}</tr>
      <tr>{state}</tr>
      </tbody></table>
    )
  }

  render(){
//     cl(this.props.value)
//     cl("render stage on/off")
//     cl(this.refs2)
    return(
      <div className="stage-on-off"
        title={(this.props?.rest?.parent||(e=>{}))({uri:"pid",pr:this.props})}
      >
      {this.showStageButtons()}
      <div className="clearfloat"></div><br/>
      
      </div>
    );
  }

}

export default StageOnOff ;
